import MyGiftModal from './ui/main/MyGiftModal';

export default MyGiftModal;
